import { memo } from 'react'
import clsx from 'clsx'
import { Chip } from '@/components/Data'
import { MarkerDataProps } from './Marker.types'
import { markerStyles as styles } from './Marker.style'
import { markerClasses, markerTypeClasses } from './Marker.data'

function Marker({ marker, active }: MarkerDataProps) {
  const { Icon, label, type, infoWindow } = marker

  return (
    <Chip
      variant="filled"
      sx={styles.chip}
      color="default"
      label={label}
      size="small"
      icon={Icon && <Icon />}
      className={clsx({
        [markerClasses.active]: infoWindow && active,
        [markerTypeClasses[type]]: Boolean(type),
      })}
    />
  )
}

export default memo(Marker)
